import React, { useContext } from 'react'

import Page from '../../components/Page'
import SchoolMetricsReport from '../../components/sections/reportBuilder/reports/SchoolMetricsReport'
import AuthContext from '../../utils/authProvider'

const SchoolMetricsReportPage = () => {
  const breadcrumb = [
    {
      path: '/',
      breadcrumbName: 'Home'
    },
    {
      path: '',
      breadcrumbName: 'School Metrics Report'
    }
  ]
  const Auth = useContext(AuthContext)
  const isSuperAdmin = Auth.hasRole('SUPER_ADMIN')
  return (
    <>
      <Page title='School Metrics Report' breadcrumb={breadcrumb}>
        <SchoolMetricsReport />
      </Page>
    </>
  )
}

export default SchoolMetricsReportPage
